import { config } from '../lib/config';

const EnvironmentSign = () => {
  const isStaging = config.env === 'staging';

  if (!isStaging) {
    return null;
  }

  return (
    <>
      <div className="fixed inset-0 pointer-events-none z-99999 border-2 border-warning" />
      <div className="fixed left-4 top-1/2 -translate-y-1/2 z-100 pointer-events-none -rotate-90 origin-left">
        <div className="px-3 py-1 text-foreground font-bold text-sm tracking-wider bg-warning rounded-br rounded-bl">
          development
        </div>
      </div>
    </>
  );
};

export default EnvironmentSign;
